import {
    ORDER_CREATE_FAIL, ORDER_CREATE_REQUEST, ORDER_CREATE_SUCCESS, ORDER_DATA_FAIL, ORDER_DATA_REQUEST, ORDER_DATA_SUCCESS, ORDER_DELIVER_FAIL, ORDER_DELIVER_REQUEST, ORDER_DELIVER_RESET, ORDER_DELIVER_SUCCESS, ORDER_DETAILS_FAIL, ORDER_DETAILS_REQUEST, ORDER_DETAILS_SUCCESS, ORDER_LIST_FAIL, ORDER_LIST_REQUEST, ORDER_LIST_SUCCESS, ORDER_MY_LIST_FAIL, ORDER_MY_LIST_REQUEST, ORDER_MY_LIST_SUCCESS, ORDER_PAY_FAIL, ORDER_PAY_REQUEST, ORDER_PAY_RESET, ORDER_PAY_SUCCESS, ORDER_SALE_DATA_FAIL, ORDER_SALE_DATA_REQUEST, ORDER_SALE_DATA_SUCCESS
} from "../../constants/orderConstants";

export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return {
        loading: true,
      };
    case ORDER_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        order: action.payload,
      };
    case ORDER_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
    /*  case ORDER_CREATE_RESET:
      return {}
    default:
      return state */
  }
};

export const orderListReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
        case ORDER_LIST_REQUEST:
            return { ...state,loading: true }
        
        case ORDER_LIST_SUCCESS:
            return { loading: false, orders: action.payload }
        
        case ORDER_LIST_FAIL:
            return { loading: false, error: action.payload }
        
        
        default:
            return state
    }
}

export const myOrderListReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
        case ORDER_MY_LIST_REQUEST:
            return { ...state,loading: true }
        
        case ORDER_MY_LIST_SUCCESS:
            return { loading: false, orders: action.payload }
        
        case ORDER_MY_LIST_FAIL:
            return { loading: false, error: action.payload }
        
        
        default:
            return state
    }
}

export const orderDetailsReducer = (state = { loading:true,orderItems: [],shippingAddress:{} }, action) => {
    switch (action.type) {
        case ORDER_DETAILS_REQUEST:
            return { ...state,loading: true }
        
        case ORDER_DETAILS_SUCCESS:
            return { loading: false, order: action.payload }
        
        case ORDER_DETAILS_FAIL:
            return { loading: false, error: action.payload }
        
        default:
            return state
    }
}


export const orderPayReducer = (state ={}, action) => {
    switch (action.type) {
        case ORDER_PAY_REQUEST:
            return { loading: true }
        
        case ORDER_PAY_SUCCESS:
            return { loading: false, success: true }
        
        case ORDER_PAY_FAIL:
            return { loading: false, error: action.payload }
            
      case ORDER_PAY_RESET:
            return { }
            
        default:
            return state
    }
}


export const orderDeliverReducer = (state ={}, action) => {
    switch (action.type) {
        case ORDER_DELIVER_REQUEST:
            return { loading: true }
        
        case ORDER_DELIVER_SUCCESS:
            return { loading: false, success: true }
        
        case ORDER_DELIVER_FAIL:
            return { loading: false, error: action.DELIVERload }
            
      case ORDER_DELIVER_RESET:
            return { }
            
        default:
            return state
    }
}


export const orderDataReducer = (state = { orderData: [] }, action) => {
    switch (action.type) {
        case ORDER_DATA_REQUEST:
            return { ...state,loading: true }
        
        case ORDER_DATA_SUCCESS:
            return { loading: false, orderData: action.payload }
        
        case ORDER_DATA_FAIL:
            return { loading: false, error: action.payload }
        
        
        default:
            return state
    }
}


export const orderSaleDataReducer = (state = { orderSaleData: [] }, action) => {
    switch (action.type) {
        case ORDER_SALE_DATA_REQUEST:
            return { ...state,loading: true }
        
        case ORDER_SALE_DATA_SUCCESS:
            return { loading: false, orderSaleData: action.payload }
        
        case ORDER_SALE_DATA_FAIL:
            return { loading: false, error: action.payload }
        
        
        default:
            return state
    }
}
